export default __webpack_public_path__ + "static/media/ic_van.13ac209d.svg";